import { useEffect } from "react";

interface UseDebouncedValidationProps {
  value: string;
  type: string;
  validateFn: (input: { type: string; value: string }) => any;
  setError: (message: string) => void;
  delay?: number;
}

export const useDebouncedValidation = ({
  value,
  type,
  validateFn,
  setError,
  delay = 500,
}: UseDebouncedValidationProps) => {
  useEffect(() => {
    if (!value) return;

    const timeoutId = setTimeout(() => {
      validateFn({ type, value })
        .unwrap()
        .then(() => setError(""))
        .catch((error: any) => {
          setError(error?.data?.description || "Validation failed");
        });
    }, delay);

    return () => clearTimeout(timeoutId);
  }, [value, type, validateFn, setError, delay]);
};
